import { render, staticRenderFns } from "./BlockDropZone.vue?vue&type=template&id=d1aa0b50&scoped=true&"
import script from "./BlockDropZone.vue?vue&type=script&lang=js&"
export * from "./BlockDropZone.vue?vue&type=script&lang=js&"
import style0 from "./BlockDropZone.vue?vue&type=style&index=0&id=d1aa0b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1aa0b50",
  null
  
)

export default component.exports